import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import { usePersistedQuery } from "@/features/order-sheet-sets/hooks/use-persisted-query";
import { TrendingBrandsQuery } from "@/features/dashboard/features/trending-brand-section/types";

export default function usePersistedLineSheetSetListQuery() {
  const { value, set, clear } = usePersistedQuery<TrendingBrandsQuery>({
    entries: {
      by: {
        parse: StringTransformer.parseString,
        stringify: StringTransformer.stringifyString,
      },
      period: {
        parse: StringTransformer.parseString,
        stringify: StringTransformer.stringifyString,
      },
      buyer_id: {
        parse: StringTransformer.parseNumber,
        stringify: StringTransformer.stringifyId,
      }
    },
  });

  return { value, set, clear };
}
